import { Box, Pagination } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { WsSelect } from '../WsSelect';
import { WsTypoColors, WsTypography, WsTypoVariants } from '../WsTypography';

export interface WsDataGridPaginationProps {
  count: number;
  page?: number;
  pageSize?: number;
  onPageSizeChange?: (pageSize: number) => void;
  onPageChange?: (event: React.ChangeEvent, page: number) => void;
}

const WsDataGridPagination = ({
  count,
  page,
  onPageChange,
  pageSize,
  onPageSizeChange,
}: WsDataGridPaginationProps) => {
  const formMethods = useForm();

  return (
    <Box display="flex" alignItems="center" my={2}>
      <FormProvider {...formMethods}>
        <Box display="flex" alignItems="center" gap={1}>
          <Box sx={{ whiteSpace: 'nowrap' }}>
            <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.SUB_TITLE}>
              Rows per page:
            </WsTypography>
          </Box>
          <Box sx={{ '& .MuiOutlinedInput-notchedOutline': { border: 'none' } }}>
            <WsSelect
              name="pageSize"
              defaultValue={String(pageSize ?? 25)}
              onChangeValue={onPageSizeChange}
              selectArray={[10, 15, 20, 25, 50, 75, 100].map((size) => ({
                label: String(size),
                value: size,
              }))}
            />
          </Box>
        </Box>
      </FormProvider>
      <Pagination
        count={count}
        page={page}
        onChange={onPageChange}
        showFirstButton
        showLastButton
        sx={{ ml: 'auto' }}
      />
    </Box>
  );
};

export default WsDataGridPagination;
